/* eslint-disable import/prefer-default-export */
import { create } from 'zustand';
import { WaypointType } from '../common/constants';

export const useMallMapStore = create((set) => ({
  selectedButton:            null,
  updateSelectedButton:      (selectedButton) => set(() => ({ selectedButton })),
  waypointType:              { value: WaypointType.Path, label: WaypointType.Path },
  setWaypointType:           (waypointType) => set(() => ({ waypointType })),
  deleteWaypointId:          null,
  setDeleteWaypointId:       (waypointId) => set(() => ({ deleteWaypointId: waypointId })),
  updateLogo:                false,
  setUpdateLogo:             (updateLogo) => set(() => ({ updateLogo })),
  selectedWaypoint:          null,
  setSelectedWaypoint:       (waypoint) => set(() => ({ selectedWaypoint: waypoint })),
  isEdgeViewMode:            false,
  toggleEdgeViewMode:        () => set((state) => ({ isEdgeViewMode: !state.isEdgeViewMode })),
  yEachMap:                  50,
  // Form
  showForm:                  true,
  toggleShowForm:            () => set((state) => ({ showForm: !state.showForm })),
  // To show waypoint labels on map
  isWaypointTextVisible:     false,
  toggleWaypointTextVisible: () => set((state) => ({ isWaypointTextVisible: !state.isWaypointTextVisible })),
  // Selected waypointLabel, needed for chaning the text rotation
  selectedWaypointLabel:     null,
  setSelectedWaypointLabel:  (waypointLabel) => set(() => ({ selectedWaypointLabel: waypointLabel })),
  // Font for textGeometry
  font:                      null,
  setFont:                   (font) => set(() => ({ font })),
}));
